import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import FeedbackInvite, { openCrispChat } from "./FeedbackInvite";
import { HELP_IMPROVE_DIALOG_SEEN_KEY } from "./constants";

const HelpImproveDialog = ({ open, onClose }) => {
  const handleDismiss = () => {
    try {
      localStorage.setItem(HELP_IMPROVE_DIALOG_SEEN_KEY, "1");
    } catch (_) {
      /* ignore quota / private mode */
    }
    onClose();
  };

  const handleSendFeedback = () => {
    openCrispChat();
    handleDismiss();
  };

  return (
    <Dialog open={open} onClose={handleDismiss} disableEnforceFocus>
      <DialogContent>
        <h3 className="dialog-title">Help us improve</h3>
        <FeedbackInvite variant="popup" omitFooter />
      </DialogContent>
      <DialogActions className="help-improve-dialog-actions">
        <button type="button" className="button" onClick={handleDismiss}>
          No feedback
        </button>
        <button
          type="button"
          className="feedback-invite__link feedback-invite__link--action"
          onClick={handleSendFeedback}
        >
          Send feedback via chat
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default HelpImproveDialog;
